import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { ref, watch, onMounted } from 'vue';
export default {
  props: {
    data: {
      type: Object,
      default: null
    },
    isNormal: {
      type: Boolean,
      default: true
    },
    showSuccess: {
      type: Boolean,
      default: false
    },
    showFail: {
      type: Boolean,
      default: false
    },
    isPk: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  components: {
    Icon: _Icon
  },
  setup: function setup(props, ctx) {
    // 显示对错的flag
    var isSelected = ref(false);
    watch(function () {
      return props.data;
    }, function (n, o) {
      if (n !== o) {
        isSelected.value = false;
      }
    });
    onMounted(function () {
      // 重置data选项select
      props.data.optionVoList.forEach(function (item) {
        item.select = false;
      });
    });
    var handleOptionClick = function handleOptionClick(item) {
      // 避免多次选择
      if (isSelected.value) {
        return;
      }
      item.select = true;
      isSelected.value = true;
      var answers = [{
        questionKey: props.data.questionKey,
        answers: [{
          questionKey: props.data.questionKey,
          optionKey: item.optionKey
        }]
      }];
      ctx.emit('submit', answers);
    };
    function judgeIsRight(item) {
      if (isSelected.value && item.isRight === 1 || !isSelected && props.showFail && item.isRight === 1) {
        return true;
      }
      if (item.select && item.isRight === 0) {
        return false;
      }
    }
    function handleSetSelect(value) {
      isSelected.value = value;
    }
    return {
      isSelected: isSelected,
      judgeIsRight: judgeIsRight,
      handleOptionClick: handleOptionClick,
      handleSetSelect: handleSetSelect
    };
  }
};